const DEFAULT_EXPERIMENT_EMAIL = 'singh.piyushssj5@gmail.com';

const experimentEmails = new Set(
  (process.env.REACT_APP_RAG_EXPERIMENT_EMAILS || DEFAULT_EXPERIMENT_EMAIL)
    .split(',').map((email) => email.trim().toLowerCase()).filter(Boolean)
);

export const hasRagExperimentAccess = (user) => Boolean(
  user?.email && experimentEmails.has(user.email.trim().toLowerCase())
);
